import styled from "styled-components";

export const StyledUploadedFiles = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
`;

export const StyledFileUploaderBox = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    margin-top: 16px;
    margin-right: 16px;
    cursor: pointer;
    background-color: var(--color-white);
    font-size: var(--size-16);
    text-align: center;
    border-radius: var(--radius-10);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);

    .image-container {
        display: flex;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: inherit;

        .fileUploaderFileImage {
            height: 100%;
        }
    }

    > .file-uploader-close {
        position: absolute;
        top: -12.5px;
        right: -12.5px;
        z-index: 1;
        width: 25px;
        height: 25px;
        color: var(--color-secondary);
    }

    .file-uploader-file {
        display: flex;
        overflow: hidden;
        color: var(--color-white);
        position: absolute;
        bottom: 0;
        align-items: center;
        width: 100%;
        height: 45px;
        background: var(--color-grey-900);
        border-radius: var(--radius-bottom-10);
        opacity: 0.8;
        svg {
            min-width: 23px;
        }

        > .file-name,
        svg {
            display: -webkit-box;
            display: -moz-box;
            overflow: hidden;
            font-size: var(--size-12);
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            -moz-box-orient: vertical;
            line-clamp: 2;
        }
    }
`;
